import { Image } from 'components/Image';

import * as S from './InfoItem.styles';

type InfoProps = {
  title: string;
  image?: string;
  file?: string;
};

export function InfoItem(props: InfoProps): React.ReactElement {
  const { title, file, image } = { ...props };

  return (
    <S.Wrapper>
      <S.ImageWrapper>
        <S.DownloadLink href={file} download target="_blank" rel="noopener noreferrer">
          <Image source={image || ''} alt={title || 'info'} />
        </S.DownloadLink>
      </S.ImageWrapper>

      {title && <S.Titles>{title}</S.Titles>}
    </S.Wrapper>
  );
}
